import { render, staticRenderFns } from "./AdminEditDeleteLinks.vue?vue&type=template&id=63ebf668"
import script from "./AdminEditDeleteLinks.vue?vue&type=script&lang=ts"
export * from "./AdminEditDeleteLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports